import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEntities = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 21"
    {...props}
  >
    <path d="M5.14 6.61a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m-2.128 5.869a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM14.15 6.906a.5.5 0 0 1 .866 0l3.03 5.25a.5.5 0 0 1-.432.75h-6.062a.5.5 0 0 1-.433-.75z" />
  </svg>
);
export default SvgEntities;
